import blancaPic from "@/public/images/artists/blanca.png";
import { Artist } from "@/types/types";

export const blanca = {
  id: "221",
  name: "Blanca",
  image: blancaPic,
  description: `Blanca's voice is bold and layered, warm and alluring, with just the right measure of presence. She moves effortlessly from mid to high registers, with a natural pull that captivates without effort.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fblanca-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Pop", "Dance", "Latin", "Ballads"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 70,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
